export const viewModeOptions = [
  { value: 'newBuildings', label: 'Жилые комплексы' },
  { value: 'offices', label: 'Офис продаж' },
];

export function getViewModeOptions(hasOffices: boolean) {
  return hasOffices ? viewModeOptions : [];
}
